import styled from 'styled-components'
import {
  BiomarkersContainer,
  Container,
  ModalMUI,
  ReadMore,
  Title,
} from '../sharedStyles'
import HealthStatus from './HealthStatus'
import MeasuredBiomarkers from './MeasuredBiomarkers'
import AboutBiomarker from './AboutBiomarker'
import { useState } from 'react'
import Percentage from './Percentage'
import { useTranslation } from 'react-i18next'
import { getScaleValue } from './PersonalizedHealthEval'
import { TextLinkify } from "./RecomendAndNextSteps";

const Background = styled.div`
  width: 100%;
`

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: fit-content;
`

const LeftSide = styled.div`
  width: 100%;
`
const RightSide = styled.div`
  float: right;
`

const Text = styled.p`
  color: var(--text-main, #1a1a1a);
  font-size: 16px;
  font-weight: 300;
  line-height: 26px;
  letter-spacing: 0.32px;
`

export const getDescription = (value: string) => {
  return `<div class='editWrap'>${(value || '')
      .replace('/(fj)(.+?)/gi', (...args) => {
        return '<span onclick="onclickreadmore(this)" className="readMore readMoreAuto"> Read More ... </span>'
      })
    }</div>`
}

const Inflamation = (props: any) => {  
  console.log('[Inflamation] RENDERED, info keys:', Object.keys(props.info || {}), 'themeId:', props.themeId)
  const { i18n } = useTranslation()
  let { themeId } = props
  const [isModalOpen, setIsOpenModal] = useState(false)

  const handleCloseModal = () => setIsOpenModal(false)
  const handleModalOpen = () => setIsOpenModal(true)
  const { info } = props
  let subject = themeId
    ? info.subjects.filter((it: any) => it._id == themeId)[0]
    : info.subjects[0]
  let indicators = themeId
    ? info.indicators.filter((it: any) => {
        let subjectId = it.subjectIds?.[0]
        return subjectId == themeId
      })
    : info.indicators
  if (!subject) {
    return <></>
  }

  const getLocalizedText = (text: any): string => {
    if (!text) return '';
    if (typeof text === 'string') return text;
    if (typeof text === 'object') {
      const currentLanguage = i18n.language;
      return text[currentLanguage] || text.en || Object.values(text)[0] || '';
    }
    return '';
  };

  const getSubjectName = (subject: any) => {
    if (!subject?.name) return '#' + subject._id
    const localizedName = getLocalizedText(subject.name);
    return localizedName || '#' + subject._id;
  }

  const isScoreMissing =
    info?.total?.value === undefined || info?.total?.value === null

  return (
    <div>
      <Background className={'paddFigma whiteprint'}>
        <div>
          <Body className='flex9' style={{ flexDirection: 'row-reverse' }}>
            <LeftSide data-animch>
              <RightSide data-animch='6' data-right-side>
                <Percentage woBorder={true} background={true} woTitle={true} {...subject} total={info?.total} />
              </RightSide>
              <Title>{getSubjectName(subject)}</Title>
              <HealthStatus
                status={subject.scaleValue || getScaleValue(info?.total)}
                isScoreMissing={isScoreMissing}
              />
              <div style={{ marginTop: '48px' }} className={'titleDesc2'}>
                <TextLinkify text={getLocalizedText(subject.description)}></TextLinkify>
              </div>
            </LeftSide>
          </Body>
          <BiomarkersContainer data-animch='3' className={'paddTs'}>
            {(indicators || []).map((it: any, index: number) => {
              return (
                <MeasuredBiomarkers
                  value={it._value}
                  indicator={it}
                  onClickResize={handleModalOpen}
                  key={index}
                />
              )
            })}
          </BiomarkersContainer>
        </div>
      </Background>
    </div>
  )
}

export default Inflamation
